export default "__VITE_ASSET__DMYnLmKN__"